import React, {Suspense} from 'react';
import './App.less';
import {Layout} from 'antd';
import AppHeader from './Components/layout/Header';
import {useSelector} from 'react-redux';
import {Content} from 'antd/es/layout/layout';
import {Route, Routes} from 'react-router';
import Footer from './Components/layout/Footer';
// import { PrivateRouteProps } from './utils/types';

const PrivateRoute = ({children, role, isPrivate}: any) => {
	const isAuthenticated = true;
	return isAuthenticated ? children : 'Access Denied';
};

function App() {
	// @ts-ignore
	const pages: any = useSelector(({routes}) => routes.data);

	const lazyLoadPage = (pagePath: string) => {
		return React.lazy(() => import(`./pages${pagePath}`));
	};
	document.title = 'Hexagon';

	return (
		<div className="App">
			<Layout className="layout">
				<AppHeader />
				<Layout style={{minHeight: '100vh'}}>
					<Content /* className='content` */>
						<Suspense fallback={<div>Loading...</div>}>
							<Routes>
								{pages.map(({path, pagePath, navBar}: any, index: number) => {
									const Component = lazyLoadPage(pagePath);
									return (
										<Route
											path={path}
											key={index}
											element={
												<PrivateRoute isPrivate={false} role={''}>
													<Component />
												</PrivateRoute>
											}
										/>
									);
								})}
							</Routes>
						</Suspense>
					</Content>
				</Layout>
				<Footer />
			</Layout>
		</div>
	);
}

export default App;
